import React from 'react';

import { WpRichTextInput } from 'Wpds/components/rich-text';
import { createFormField } from 'Shared/utils/createFormField';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = Readonly<{
  value?;
  autoFocus?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange: Function;
  qaTest?: string;
}>;

function FormRichTextInput({ value, autoFocus = false, disabled = false, onChange, placeholder, qaTest }: Props) {
  const { tr } = useTranslation();
  const effectivePlaceholder = placeholder ?? tr('common.placeholders.enter_text');

  return (
    <WpRichTextInput
      value={value}
      onChange={onChange}
      autoFocus={autoFocus}
      disabled={disabled}
      placeholder={effectivePlaceholder}
      qaTest={qaTest}
    />
  );
}

export default createFormField(FormRichTextInput);
